import _ from 'lodash';
import React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Field, FormSpy } from "react-final-form";

import InputWrapper from '../../../common/forms/InputWrapper';
import ColorPickerWrapper from '../../../common/forms/ColorPickerWrapper';
import UploadDocumentWrapper from '../../../common/forms/UploadDocumentWrapper';
import { GRAY_COLOR } from '../../../../constants/css';
import {ReactComponent as FontIcon} from '../../../../images/icons/font_icon.svg';
import { StyledFormHeading } from '../../../common/styles/FormStyles';
import { Tooltip } from '../../../common/lib/Tooltip';

class EmailBaseDesignFontSelectionForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayPrimaryFontColor: false,
      displaySecondaryFontColor: false,
      primaryColor: "",
      secondaryColor: "",
    };
  }

  handlePrimaryFontFileSelected(selectedFiles, form) {
    const fileObj = selectedFiles[0];
    const fontName = _.split(fileObj.name, '.')[0];
    form.change('bt_definition_font_type', _.upperFirst(fontName));
  }

  handleSecondaryFontFileSelected(selectedFiles, form) {
    const fileObj = selectedFiles[0];
    const fontName = _.split(fileObj.name, '.')[0];
    form.change('bt_definition_font_type_two', _.upperFirst(fontName));
  }

  handlePrimaryColorClick = () => {
    this.setState({
      displayPrimaryFontColor: !this.state.displayPrimaryFontColor
    });
  };

  handleSecondaryColorClick = () => {
    this.setState({
      displaySecondaryFontColor: !this.state.displaySecondaryFontColor
    });
  };

  handleClosePrimaryColor = () => {
    this.setState({ displayPrimaryFontColor: false });
  };

  handleCloseSecondaryColor = () => {
    this.setState({ displaySecondaryFontColor: false });
  };

  handlePrimaryColorChange = color => {
    this.setState({ primaryColor: color.hex });
  };

  handleSecondaryColorChange = color => {
    this.setState({ secondaryColor: color.hex });
  };

  handlePrimaryFontFileDeleted(form){
    form.change('primary_font', '');
    form.change('bt_definition_font_type', '');
  }

  handlePrimaryFontBoldFileDeleted(form){
    form.change('primary_font_bold', '');
  }

  handleSecondaryFontFileDeleted(form){
    form.change('secondary_font', '');
    form.change('bt_definition_font_type_two', '');
  }

  handleSecondaryFontBoldFileDeleted(form){
    form.change('secondary_font_bold', '');
  }

  render() {
    return (
      <FormSpy subscription={{ values: true, form: true }}>
        {({ values, form }) => {
          const selectedPrimaryFontFile = values.primary_font;
          const selectedPrimaryFontBoldFile = values.primary_font_bold;
          const selectedSecondaryFontFile = values.secondary_font;
          const selectedSecondaryFontBoldFile = values.secondary_font_bold;
          const selectedFontColor = values.bt_definition_font_color || this.state.primaryColor;
          const selectedFontColorTwo = values.bt_definition_font_color_two || this.state.secondaryColor;

          return (
            <Row>
              <Col md={6} lg={6}>
                <fieldset>
                  <StyledFormHeading>
                    SCHRIFTART PRIMÄR
                    <Tooltip>
                      Die Standardschriftart wird für Fließtexte in PDF Dokumenten verwendet. Die fette Schriftart wird für Betreffzeile, Tabellenüberschriften und Teilabschnitt-Überschriften verwendet.
                    </Tooltip>
                  </StyledFormHeading>
                  <Row>
                    <Col md={8} lg={8}>
                      <Field
                        name="bt_definition_font_type"
                        type="text"
                        labelText="Schriftart Name"
                        disabled={true}
                        component={InputWrapper}
                      />
                    </Col>
                    <Col md={4} lg={4}>
                      <Field
                        name="bt_definition_font_color"
                        labelText="Schriftfarbe"
                        component={ColorPickerWrapper}
                        handleClose={this.handleClosePrimaryColor}
                        handleInputClick={this.handlePrimaryColorClick}
                        displayPicker={this.state.displayPrimaryFontColor}
                        isColorBox={true}
                        selectedColor={selectedFontColor}
                        handleInputChange={this.handlePrimaryColorChange}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} lg={12}>
                      <Form.Label className="mt-5 mb-3">Upload Schriftart: Standard</Form.Label>
                      <Field
                        name="primary_font"
                        component={UploadDocumentWrapper}
                        text="Bitte laden Sie eine Standard Schrift hoch. Mögliche Formate: .woff, .tff"
                        icon={<FontIcon width='38px'/>}
                        backgroundColor={GRAY_COLOR}
                        widthText="280px"
                        selectedFile={selectedPrimaryFontFile}
                        onDropCustomHandler={(files) =>
                          this.handlePrimaryFontFileSelected(files, form)
                        }
                        acceptedTypes={[".woff", ".ttf"]}
                        onDeleteFile={() =>
                          this.handlePrimaryFontFileDeleted(form)
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} lg={12}>
                      <Form.Label className="mt-5 mb-3">Upload Schriftart: Fett</Form.Label>
                      <Field
                        name="primary_font_bold"
                        component={UploadDocumentWrapper}
                        text="Bitte laden Sie eine Standard Schrift hoch. Mögliche Formate: .woff, .tff"
                        icon={<FontIcon width='38px'/>}
                        backgroundColor={GRAY_COLOR}
                        widthText="280px"
                        selectedFile={selectedPrimaryFontBoldFile}
                        acceptedTypes={[".woff", ".ttf"]}
                        onDeleteFile={() =>
                          this.handlePrimaryFontBoldFileDeleted(form)
                        }
                      />
                    </Col>
                  </Row>
                </fieldset>
              </Col>
              <Col md={6} lg={6}>
                <fieldset>
                  <StyledFormHeading>
                    SCHRIFTART SEKUNDÄR
                    <Tooltip>
                      Die Standardschriftart wird für die Fußzeile in PDF Dokumenten verwendet.
                    </Tooltip>
                  </StyledFormHeading>
                  <Row>
                    <Col md={6} lg={6}>
                      <Field
                        name="bt_definition_font_type_two"
                        type="text"
                        labelText="Schriftart Name"
                        disabled={true}
                        component={InputWrapper}
                      />
                    </Col>
                    <Col md={6} lg={6}>
                      <Field
                        name="bt_definition_font_color_two"
                        labelText="Schriftfarbe"
                        component={ColorPickerWrapper}
                        handleClose={this.handleCloseSecondaryColor}
                        handleInputClick={this.handleSecondaryColorClick}
                        displayPicker={this.state.displaySecondaryFontColor}
                        isColorBox={true}
                        selectedColor={selectedFontColorTwo}
                        handleInputChange={this.handleSecondaryColorChange}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} lg={12}>
                      <Form.Label className="mt-5 mb-3">Upload Schriftart: Standard</Form.Label>
                      <Field
                        name="secondary_font"
                        component={UploadDocumentWrapper}
                        text="Bitte laden Sie eine Standard Schrift hoch. Mögliche Formate: .woff, .tff"
                        widthText="280px"
                        icon={<FontIcon width='38px'/>}
                        backgroundColor={GRAY_COLOR}
                        selectedFile={selectedSecondaryFontFile}
                        onDropCustomHandler={(files) =>
                          this.handleSecondaryFontFileSelected(files, form)
                        }
                        acceptedTypes={[".woff", ".ttf"]}
                        onDeleteFile={() =>
                          this.handleSecondaryFontFileDeleted(form)
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} lg={12}>
                      <Form.Label className="mt-5 mb-3">Upload Schriftart: Fett</Form.Label>
                      <Field
                        name="secondary_font_bold"
                        component={UploadDocumentWrapper}
                        text="Bitte laden Sie eine Standard Schrift hoch. Mögliche Formate: .woff, .tff"
                        widthText="280px"
                        icon={<FontIcon width='38px'/>}
                        backgroundColor={GRAY_COLOR}
                        selectedFile={selectedSecondaryFontBoldFile}
                        acceptedTypes={[".woff", ".ttf"]}
                        onDeleteFile={() =>
                          this.handleSecondaryFontBoldFileDeleted(form)
                        }
                      />
                    </Col>
                  </Row>
                </fieldset>
              </Col>
            </Row>
          );
        }}
      </FormSpy>
    );
  }
}

export default EmailBaseDesignFontSelectionForm;
